import ACTIONS, { FETCH_STATUS } from "../constants";

export const getMilestonesAttempt = {
    pending: {
        type: ACTIONS.MILESTONE.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data) => ({
        type: ACTIONS.MILESTONE.SUCCESS,
        data,
        status: FETCH_STATUS.SUCCESS,
    }),
    error: (error) => ({
        type: ACTIONS.MILESTONE.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getMilestonesRequest = (state) => ({
    type: ACTIONS.MILESTONE_CALL,
    payload: state,
});

export const getMilestoneAttempt = {
    pending: {
        type: ACTIONS.MILESTONE_DETAILS.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data) => ({
        type: ACTIONS.MILESTONE_DETAILS.SUCCESS,
        data,
        status: FETCH_STATUS.SUCCESS,
    }),
    error: (error) => ({
        type: ACTIONS.MILESTONE_DETAILS.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getMilestoneRequest = (state) => ({
    type: ACTIONS.MILESTONE_DETAILS_CALL,
    payload: state,
});

export const createMilestoneAttempt = {
    pending: {
        type: ACTIONS.CREATE_MILESTONE.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data) => ({
        type: ACTIONS.CREATE_MILESTONE.SUCCESS,
        data,
        status: FETCH_STATUS.SUCCESS,
    }),
    error: (error) => ({
        type: ACTIONS.CREATE_MILESTONE.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const createMilestoneRequest = (state) => ({
    type: ACTIONS.CREATE_MILESTONE_CALL,
    payload: state,
});

export const updateMilestoneAttempt = {
    pending: {
        type: ACTIONS.UPDATE_MILESTONE.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data) => ({
        type: ACTIONS.UPDATE_MILESTONE.SUCCESS,
        data,
        status: FETCH_STATUS.SUCCESS,
    }),
    error: (error) => ({
        type: ACTIONS.UPDATE_MILESTONE.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const updateMilestoneRequest = (state) => ({
    type: ACTIONS.UPDATE_MILESTONE_CALL,
    payload: state,
});

export const deleteMilestoneAttempt = {
    pending: {
        type: ACTIONS.DELETE_MILESTONE.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data) => ({
        type: ACTIONS.DELETE_MILESTONE.SUCCESS,
        data,
        status: FETCH_STATUS.SUCCESS,
    }),
    error: (error) => ({
        type: ACTIONS.DELETE_MILESTONE.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const deleteMilestoneRequest = (state) => ({
    type: ACTIONS.DELETE_MILESTONE_CALL,
    payload: state,
});

export const updateMilestoneFlagAttempt = {
    pending: {
        type: ACTIONS.MILESTONE_FLAG.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data) => ({
        type: ACTIONS.MILESTONE_FLAG.SUCCESS,
        data,
        status: FETCH_STATUS.SUCCESS,
    }),
    error: (error) => ({
        type: ACTIONS.MILESTONE_FLAG.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const updateMilestoneFlagRequest = (state) => ({
    type: ACTIONS.MILESTONE_FLAG_CALL,
    payload: state,
});

export const clearCurrentMilestoneAttempt = {
    success: {
        type: ACTIONS.CLEAR_CURRENT_MILESTONE.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
    },
};

export const clearCurrentMilestoneRequest = (state) => ({
    type: ACTIONS.CLEAR_CURRENT_MILESTONE_CALL,
    payload: state,
});

export const resetMilestoneErrorsAttempt = {
    success: {
        type: ACTIONS.RESET_MILESTONE_ERRORS.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
    },
};

export const resetMilestoneErrorsRequest = (state) => ({
    type: ACTIONS.RESET_MILESTONE_ERRORS_CALL,
    payload: state,
});